import { gql } from '@apollo/client'

export const Query = gql`
  query EditAssetType($companyId: ID!, $filters: AssetTypeFilters) {
    assetTypes(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        costCents
        rateCents
        availableToEvents
        displayOnWebsite
        description
        weight
        manufacturer
        model
        stockCount
        documentCategory {
          id
          name
          color
        }
        taxRate {
          id
          name
          rate
        }
        mystroTestId
      }
    }
  }
`
